import { j as r } from "../../../jsx-runtime-B6kdoens.js";
import { c as n, f as p } from "../../../create-component-CBAeEoQ6.js";
const m = n(
  "Select Option",
  p(
    ({ children: t, ...o }, e) => /* @__PURE__ */ r.jsx("option", { ref: e, ...o, children: t })
  )
);
export {
  m as SelectOption
};
//# sourceMappingURL=index.js.map
